"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSubHeader = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("../../../assets/styles/config");
exports.StyledSubHeader = styled_components_1.default.h2 `
  color: ${config_1.colors.black};
  font: bold ${config_1.fontSizes.big} ${config_1.fontFamilies.primary};
  margin: 25px 0 10px;
`;
